import dayjs from "dayjs";

import { Check, Timer as TimerIcon } from "@mui/icons-material";
import { Stack, Box, BoxProps } from "@mui/material";
import { T } from "components/util/t";
import { Timer, TimerSize } from "components/routes/events/Timer";
import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/material";

export const HeatHeader: React.FC<{
    heat: any,
    isNext: boolean,
    forceShowScheduled: boolean,
    displayFormat?: string,
    displayTimerIcon: boolean,
    actions: React.ReactNode,
    className?: string,
    heatTimeStyles?: BoxProps["sx"] | SxProps<Theme>
    timerSize?: TimerSize,
}> = ({
    heat,
    isNext,
    forceShowScheduled,
    displayFormat = "hh:mm a",
    displayTimerIcon,
    actions,
    className = "",
    heatTimeStyles,
    timerSize = "sm",
}) => {

    const renderUpcoming = () => {
        const scheduledTime = (forceShowScheduled || !heat.getIn(["config", "hide_scheduled_time"])) && heat.get("scheduled_time");

        return scheduledTime &&
            <div>
                <Stack direction="row" spacing={1} alignItems="center">
                    <span className="heat-time" data-testid="heat-time">
                        {dayjs(scheduledTime).format(displayFormat)}
                    </span>
                </Stack>
            </div>;
    };

    const renderStarted = () =>
        heat.getIn(["config", "hide_timer"]) ?
            <span className="heat-time flag" data-testid="heat-time">
                <span><T>LIVE</T></span>
            </span> :
            <>
                {displayTimerIcon && <TimerIcon/>}
                <Stack direction="row" spacing={1} alignItems="center">
                    <Box component="span" sx={heatTimeStyles} data-testid="heat-time">
                        <Timer
                            start={heat.get("start_time")}
                            duration={heat.get("heat_duration_minutes")}
                            resume={heat.get("resume_time")}
                            remainingMillisecondsOnPause={heat.get("remaining_milliseconds_on_pause")}
                            size={timerSize}
                        />
                    </Box>
                </Stack>
            </>;

    const renderFinished = () =>
        <span className="heat-time" data-testid="heat-time">
            <Check className="done" />
        </span>;

    const renderNext = () =>
        <Stack direction="row" spacing={1} alignItems="center">
            <span className="heat-time flag" data-testid="heat-time">
                <T>NEXT</T>
            </span>
        </Stack>;

    const renderTime = () => {
        const heatFinished = heat.get("end_time"),
            heatStarted = heat.get("start_time");
        return isNext ? renderNext() :
            heatFinished ? renderFinished() :
                heatStarted ? renderStarted() : renderUpcoming();
    };

    return (
        <header className={`heat-header ${className}`}>
            {actions && <div className="heat-actions">{actions}</div>}
            <T heat={heat}>HeatHeader_title</T>
            {renderTime()}
        </header>
    );
};
